export default __webpack_public_path__ + "static/media/Path3421.751b7dca.svg";